// extracted by mini-css-extract-plugin
export var dialog = "ImageDialog-module--dialog--TXcYY";
export var imgButton = "ImageDialog-module--imgButton--o6g0J";
export var leftButton = "ImageDialog-module--leftButton--V3OR6";
export var rightButton = "ImageDialog-module--rightButton--WZAU1";